import React from 'react';
import styles from "./Table.module.css";
import { useTable, useSortBy } from 'react-table';

function Table({ data }) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Cultura',
        accessor: 'cultura',
      },
      {
        Header: 'Contagem de Natureza',
        accessor: 'natureza',
      },
      {
        Header: 'Soma de Produção',
        accessor: 'producao',
        Cell: ({ row }) => {
          const producao = row.original.producao ?? 0;
          const unidade = row.original.unidade;
          return `${producao.toLocaleString('pt-BR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })} ${unidade || ''}`;
        }
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data }, useSortBy);

  return (
    <div className={styles.tableContainer}>
      <table {...getTableProps()} className={styles.table}>
        <thead>
          {headerGroups.map(headerGroup => {
            const { key: headerGroupKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={headerGroupKey} {...headerGroupProps} className={styles.thead}>
                {headerGroup.headers.map(column => {
                  const { key: headerKey, ...headerProps } = column.getHeaderProps(column.getSortByToggleProps());
                  return (
                    <th key={headerKey} {...headerProps} scope="col">
                      {column.render('Header')}
                      <span className={styles.sortIcon}>
                        {column.isSorted ? (column.isSortedDesc ? '▼' : '▲') : ''}
                      </span>
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()} className={styles.tbody}>
          {rows.map(row => {
            prepareRow(row);
            const { key: rowKey, ...rowProps } = row.getRowProps();
            return (
              <tr key={rowKey} {...rowProps}>
                {row.cells.map(cell => {
                  const { key: cellKey, ...cellProps } = cell.getCellProps();
                  return (
                    <td key={cellKey} {...cellProps} className={styles.centerAlign}>
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
